<template>
  <div class="container">
    <div v-if="!orderbool">
      <h3 class="green subtitle">
        {{ $translate('subtitle_form_model_suola') }}
      </h3>
      <hr />
    </div>
    <div class="columns">
      <div class="column">
        <div class="columns">
          <div class="column">
            <img
              :src="image1 == null ? 'https://place-hold.it/150x150' : image1"
              style="max-width: 150px; max-height: 150px"
            />
          </div>

          <div class="column">
            <b-field
              :type="{ 'is-danger': errors.has('battmat') }"
              :label="$translate('battmat') | capitalize"
              :message="errors.first('battmat')"
            >
              <b-select
                v-model="mod.battmat"
                v-validate="{ required: baseRequired }"
                :disabled="disabledbool || disabledboolcolor"
                name="battmat"
                :placeholder="$translate('placeholder_select')"
                @input="changepell1"
              >
                <option
                  v-for="optio in availablebatt"
                  :key="optio.id"
                  :value="optio.id"
                  :label="$translateMaterial(optio)"
                >
                  {{ $translateMaterial(optio) }}
                </option>
              </b-select>
            </b-field>
            <b-field
              v-show="mod.battmat != null"
              :message="errors.first('battvar')"
              :type="{ 'is-danger': errors.has('battvar') }"
              :label="$translate('battvar') | capitalize"
            >
              <b-select
                v-model="mod.battvar"
                v-validate="{ required: baseRequired || !!mod.battmat }"
                :disabled="disabledbool || disabledboolcolor"
                name="battvar"
                :placeholder="$translate('placeholder_select')"
                @input="changeImage1"
              >
                <template v-for="optio in availablebatt">
                  <template v-if="optio.id == mod.battmat">
                    <option v-for="variant in optio.variants" :key="variant.id" :value="variant.id">
                      {{ $translateMaterialVariant(variant) }}
                    </option>
                  </template>
                </template>
              </b-select>
            </b-field>
          </div>
        </div>

        <div class="columns">
          <div class="column">
            <img
              :src="image3 == null ? 'https://place-hold.it/150x150' : image3"
              style="max-width: 150px; max-height: 150px"
            />
          </div>

          <div class="column">
            <b-field
              :type="{ 'is-danger': errors.has('tacczepp') }"
              :label="$translate('tacczepp') | capitalize"
              :message="errors.first('tacczepp')"
            >
              <b-select
                v-model="mod.tacczepp"
                v-validate="{ required: baseRequired }"
                :disabled="disabledbool || disabledboolcolor"
                name="tacczepp"
                :placeholder="$translate('placeholder_select')"
                @input="changepell3"
              >
                <option
                  v-for="optio in availabletacczepp"
                  :key="optio.id + 'tacczepp'"
                  :value="optio.id"
                  :label="$translateMaterial(optio)"
                >
                  {{ $translateMaterial(optio) }}
                </option>
              </b-select>
            </b-field>
            <b-field
              v-show="mod.tacczepp != null"
              :message="errors.first('tacczeppvar')"
              :type="{ 'is-danger': errors.has('tacczeppvar') }"
              :label="$translate('tacczeppvar') | capitalize"
            >
              <b-select
                v-model="mod.tacczeppvar"
                v-validate="{ required: baseRequired || !!mod.tacczepp }"
                :disabled="disabledbool || disabledboolcolor"
                name="tacczeppvar"
                :placeholder="$translate('placeholder_select')"
                @input="changeImage3"
              >
                <template v-for="optio in availableinter">
                  <template v-if="optio.id == mod.tacczepp">
                    <option v-for="variant in optio.variants" :key="variant.id + 'tacczeppvar'" :value="variant.id">
                      {{ $translateMaterialVariant(variant) }}
                    </option>
                  </template>
                </template>
              </b-select>
            </b-field>
          </div>
        </div>

        <div class="columns">
          <div class="column">
            <img
              :src="image2 == null ? 'https://place-hold.it/150x150' : image2"
              style="max-width: 150px; max-height: 150px"
            />
          </div>

          <div class="column">
            <b-field
              :type="{ 'is-danger': errors.has('intemat') }"
              :label="$translate('intemat') | capitalize"
              :message="errors.first('intemat')"
            >
              <b-select
                v-model="mod.intemat"
                v-validate="{ required: !orderbool }"
                :disabled="disabledbool || disabledboolcolor"
                name="intemat"
                :placeholder="$translate('placeholder_select')"
                @input="changepell2"
              >
                <option key="Noone" value="Noone" :label="$translate('Noone')" />
                <option
                  v-for="optio in availableinter"
                  :key="optio.id"
                  :value="optio.id"
                  :label="$translateMaterial(optio)"
                >
                  {{ $translateMaterial(optio) }}
                </option>
              </b-select>
            </b-field>
            <b-field
              v-show="mod.intemat != null && mod.intemat != 'Noone'"
              :message="errors.first('intevar')"
              :type="{ 'is-danger': errors.has('intevar') }"
              :label="$translate('intevar') | capitalize"
            >
              <b-select
                v-model="mod.intevar"
                v-validate="{ required: (!orderbool || !!mod.intemat) && mod.intemat != 'Noone' }"
                :disabled="disabledbool || disabledboolcolor"
                name="intevar"
                :placeholder="$translate('placeholder_select')"
                @input="changeImage2"
              >
                <template v-for="optio in availableinter">
                  <template v-if="optio.id == mod.intemat">
                    <option v-for="variant in optio.variants" :key="variant.id" :value="variant.id">
                      {{ $translateMaterialVariant(variant) }}
                    </option>
                  </template>
                </template>
              </b-select>
            </b-field>
          </div>
        </div>
      </div>
    </div>
    <div class="columns">
      <div class="column">
        <div class="field">
          <b-checkbox v-model="mod.punt_risv" :disabled="disabledbool || disabledtacc">
            {{ $translate('punt_risv') | capitalize }}
          </b-checkbox>
        </div>
        <div class="columns">
          <div class="column is-6">
            <b-field
              :type="{ 'is-danger': errors.has('tacc') }"
              :message="errors.first('tacc')"
              :label="$translate('tacc') | capitalize"
            >
              <b-select
                v-model="mod.tacc"
                v-validate="{ required: foggiaRequired }"
                :disabled="disabledbool"
                name="tacc"
                :placeholder="$translate('placeholder_select')"
                @input="
                  mod.taccvar = null
                  if (mod.tacc == 'foggiafondo2') {
                    mod.intemat = 'Noone'
                    mod.intevar = null
                  }
                "
              >
                <option :key="null" :value="null" :label="$translate('Noone')" />
                <option v-for="optio in $foggiafondo" :key="optio.key" :value="optio.key">
                  {{ $translate(optio.key) | capitalize }}
                </option>
              </b-select>
            </b-field>
          </div>
          <div class="column is-6">
            <template v-if="$foggiafondo.find(temp => temp.key === mod.tacc) != undefined">
              <b-field
                v-show="mod.tacc != null"
                :type="{ 'is-danger': errors.has('taccvar') }"
                :message="errors.first('taccvar')"
                :label="$translate('taccvar') | capitalize"
              >
                <b-select
                  v-model="mod.taccvar"
                  v-validate="{ required: foggiaRequired || !!mod.tacc }"
                  :disabled="disabledbool"
                  type="textarea"
                  name="taccvar"
                  :placeholder="$translate('placeholder_select')"
                >
                  <option
                    v-for="variant in $foggiafondo.find(temp => temp.key === mod.tacc).variant"
                    :key="variant.key"
                    :disabled="disabledbool"
                    :value="variant.key"
                  >
                    {{ $translate(variant.key) | capitalize }}
                  </option>
                </b-select>
              </b-field>
            </template>
          </div>
        </div>

        <template v-if="orderbool && mod.tacc && mod.taccvar">
          <hr />
          <b-field horizontal>
            <strong>{{ $translate('left_foot') }}</strong>
            <strong>{{ $translate('right_foot') }}</strong>
          </b-field>
          <b-field v-if="mod.tacc == 'foggiafondo2' && !isSimplified" :label="$translate('pos_batt')" horizontal>
            <b-select
              v-model="mod.pos_batt_sx"
              :placeholder="$translate('placeholder_select')"
              type="number"
              :disabled="disabledbool"
            >
              <option value="normal">
                {{ $translate('normal') | capitalize }}
              </option>
              <option value="batt_ava">
                {{ $translate('batt_ava') | capitalize }}
              </option>
              <option value="batt_arr">
                {{ $translate('batt_arr') | capitalize }}
              </option>
            </b-select>
            <b-select
              v-model="mod.pos_batt_dx"
              type="number"
              :placeholder="$translate('placeholder_select')"
              :disabled="disabledbool"
            >
              <option value="normal">
                {{ $translate('normal') | capitalize }}
              </option>
              <option value="batt_ava">
                {{ $translate('batt_ava') | capitalize }}
              </option>
              <option value="batt_arr">
                {{ $translate('batt_arr') | capitalize }}
              </option>
            </b-select>
          </b-field>

          <b-field v-if="mod.tacc == 'foggiafondo2' && !isSimplified" :label="$translate('dir_deamb')" horizontal>
            <b-select
              v-model="mod.dir_deamb_sx"
              :placeholder="$translate('placeholder_select')"
              type="number"
              :disabled="disabledbool"
            >
              <option value="normal">
                {{ $translate('normal') | capitalize }}
              </option>
              <option value="in_pron">
                {{ $translate('in_pron') | capitalize }}
              </option>
              <option value="in_sup">
                {{ $translate('in_sup') | capitalize }}
              </option>
            </b-select>
            <b-select
              v-model="mod.dir_deamb_dx"
              type="number"
              :placeholder="$translate('placeholder_select')"
              :disabled="disabledbool"
            >
              <option value="normal">
                {{ $translate('normal') | capitalize }}
              </option>
              <option value="in_pron">
                {{ $translate('in_pron') | capitalize }}
              </option>
              <option value="in_sup">
                {{ $translate('in_sup') | capitalize }}
              </option>
            </b-select>
          </b-field>

          <b-field :label="$translate('sumss_post')" horizontal>
            <b-field :type="{ 'is-danger': errors.has('smuss_post_sx') }">
              <b-select
                v-model="mod.smuss_post_sx"
                v-validate="{ required: mod.suola_finn_sx != undefined && mod.suola_finn_sx }"
                name="smuss_post_sx"
                :placeholder="$translate('placeholder_select')"
                :disabled="disabledbool"
              >
                <option v-if="!mod.suola_finn_sx" value="no_smuss">
                  {{ $translate('no_smuss') | capitalize }}
                </option>
                <option v-if="!mod.suola_finn_sx" value="like_catalog">
                  {{ $translate('like_catalog') | capitalize }}
                </option>
                <option value="smuss_post">
                  {{ $translate('smuss_post') | capitalize }}
                </option>
                <option value="smuss_long">
                  {{ $translate('smuss_long') | capitalize }}
                </option>
                <option value="smuss_post_lat">
                  {{ $translate('smuss_post_lat') | capitalize }}
                </option>
                <option value="smuss_post_med">
                  {{ $translate('smuss_post_med') | capitalize }}
                </option>
              </b-select>
            </b-field>
            <b-field :type="{ 'is-danger': errors.has('smuss_post_dx') }">
              <b-select
                v-model="mod.smuss_post_dx"
                v-validate="{ required: mod.suola_finn_dx != undefined && mod.suola_finn_dx }"
                name="smuss_post_dx"
                :placeholder="$translate('placeholder_select')"
                :disabled="disabledbool"
              >
                <option v-if="!mod.suola_finn_dx" value="no_smuss">
                  {{ $translate('no_smuss') | capitalize }}
                </option>
                <option v-if="!mod.suola_finn_dx" value="like_catalog">
                  {{ $translate('like_catalog') | capitalize }}
                </option>
                <option value="smuss_post">
                  {{ $translate('smuss_post') | capitalize }}
                </option>
                <option value="smuss_long">
                  {{ $translate('smuss_long') | capitalize }}
                </option>
                <option value="smuss_post_lat">
                  {{ $translate('smuss_post_lat') | capitalize }}
                </option>
                <option value="smuss_post_med">
                  {{ $translate('smuss_post_med') | capitalize }}
                </option>
              </b-select>
            </b-field>
          </b-field>
          <b-field :label="$translate('camp_M')" horizontal>
            <b-select
              v-model="mod.camp_M_sx"
              :placeholder="$translate('placeholder_select')"
              :disabled="disabledbool"
              @input="EmptyCamp('camp_num_M_sx')"
            >
              <option value="normal">
                {{ $translate('normal') | capitalize }}
              </option>
              <option value="sfilata">
                {{ $translate('sfilata') | capitalize }}
              </option>
              <option value="thickless">
                {{ $translate('thickless') | capitalize }}
              </option>
              <option value="large">
                {{ $translate('large') | capitalize }}
              </option>
              <option value="free">
                {{ $translate('free') | capitalize }}
              </option>
            </b-select>
            <b-input
              v-model="campValueMedSx"
              :disabled="mod.camp_M_sx != 'free' || disabledbool"
              type="number"
              :placeholder="$translate('placeholder_numeric')"
              @input="UpdateCamp()"
            />
            <b-select
              v-model="mod.camp_M_dx"
              :placeholder="$translate('placeholder_select')"
              :disabled="disabledbool"
              @input="EmptyCamp('camp_num_M_dx')"
            >
              <option value="normal">
                {{ $translate('normal') | capitalize }}
              </option>
              <option value="sfilata">
                {{ $translate('sfilata') | capitalize }}
              </option>
              <option value="thickless">
                {{ $translate('thickless') | capitalize }}
              </option>
              <option value="large">
                {{ $translate('large') | capitalize }}
              </option>
              <option value="free">
                {{ $translate('free') | capitalize }}
              </option>
            </b-select>
            <b-input
              v-model="campValueMedDx"
              :disabled="mod.camp_M_dx != 'free' || disabledbool"
              type="number"
              :placeholder="$translate('placeholder_numeric')"
              @input="UpdateCamp()"
            />
          </b-field>

          <b-field :label="$translate('camp_L')" horizontal>
            <b-select
              v-model="mod.camp_L_sx"
              :placeholder="$translate('placeholder_select')"
              :disabled="disabledbool"
              @input="EmptyCamp('camp_num_L_sx')"
            >
              <option value="normal">
                {{ $translate('normal') | capitalize }}
              </option>
              <option value="sfilata">
                {{ $translate('sfilata') | capitalize }}
              </option>
              <option value="thickless">
                {{ $translate('thickless') | capitalize }}
              </option>
              <option value="large">
                {{ $translate('large') | capitalize }}
              </option>
              <option value="free">
                {{ $translate('free') | capitalize }}
              </option>
            </b-select>
            <b-input
              v-model="campValueLatSx"
              :disabled="mod.camp_L_sx != 'free' || disabledbool"
              type="number"
              :placeholder="$translate('placeholder_numeric')"
              @input="UpdateCamp()"
            />

            <b-select
              v-model="mod.camp_L_dx"
              :placeholder="$translate('placeholder_select')"
              :disabled="disabledbool"
              @input="EmptyCamp('camp_num_L_dx')"
            >
              <option value="normal">
                {{ $translate('normal') | capitalize }}
              </option>
              <option value="sfilata">
                {{ $translate('sfilata') | capitalize }}
              </option>
              <option value="thickless">
                {{ $translate('thickless') | capitalize }}
              </option>
              <option value="large">
                {{ $translate('large') | capitalize }}
              </option>
              <option value="free">
                {{ $translate('free') | capitalize }}
              </option>
            </b-select>
            <b-input
              v-model="campValueLatDx"
              :disabled="mod.camp_L_dx != 'free' || disabledbool"
              type="number"
              :placeholder="$translate('placeholder_numeric')"
              @input="UpdateCamp()"
            />
          </b-field>

          <b-field v-if="mod.tacc == 'foggiafondo0' && !isSimplified" :label="$translate('impr_ground')" horizontal>
            <b-select
              v-model="mod.impr_ground_sx"
              :placeholder="$translate('placeholder_select')"
              :disabled="disabledbool"
            >
              <option value="normal">
                {{ $translate('normal') | capitalize }}
              </option>
              <option value="halfthommed">
                {{ $translate('halfthommed') | capitalize }}
              </option>
              <option value="halfthomlat">
                {{ $translate('halfthomlat') | capitalize }}
              </option>
            </b-select>
            <b-select
              v-model="mod.impr_ground_dx"
              :placeholder="$translate('placeholder_select')"
              :disabled="disabledbool"
            >
              <option value="normal">
                {{ $translate('normal') | capitalize }}
              </option>
              <option value="halfthommed">
                {{ $translate('halfthommed') | capitalize }}
              </option>
              <option value="halfthomlat">
                {{ $translate('halfthomlat') | capitalize }}
              </option>
            </b-select>
          </b-field>
          <b-field v-if="!isSimplified" :label="$translate('ammmm')" horizontal class="has-text-centered">
            <b-checkbox v-model="mod.ammmm_sx" :disabled="disabledbool" />
            <b-checkbox v-model="mod.ammmm_dx" :disabled="disabledbool" />
          </b-field>
          <!--<b-field
            :label="$translate('zepp_pell')"
            horizontal
            class="has-text-centered"
            v-if="mod.tacc == 'foggiafondo2' || mod.tacc == 'foggiafondo1'"
          >
            <b-checkbox v-model="mod.zepp_pell_sx"></b-checkbox>
            <b-checkbox v-model="mod.zepp_pell_dx"></b-checkbox>
          </b-field>-->
          <b-field
            v-if="mod.tacc == 'foggiafondo2' && !isSimplified"
            :label="$translate('suola_finn')"
            horizontal
            class="has-text-centered"
          >
            <b-checkbox
              v-model="mod.suola_finn_sx"
              :disabled="disabledbool"
              @input="
                mod.suola_finn_dx = mod.suola_finn_sx
                if (mod.smuss_post_dx == 'no_smuss' || mod.smuss_post_dx == 'like_catalog') {
                  mod.smuss_post_dx = null
                }
                if (mod.smuss_post_sx == 'no_smuss' || mod.smuss_post_sx == 'like_catalog') {
                  mod.smuss_post_sx = null
                }
              "
            />
            <b-checkbox
              v-model="mod.suola_finn_dx"
              :disabled="disabledbool"
              @input="
                mod.suola_finn_sx = mod.suola_finn_dx
                if (mod.smuss_post_dx == 'no_smuss' || mod.smuss_post_dx == 'like_catalog') {
                  mod.smuss_post_dx = null
                }
                if (mod.smuss_post_sx == 'no_smuss' || mod.smuss_post_sx == 'like_catalog') {
                  mod.smuss_post_sx = null
                }
              "
            />
          </b-field>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import '../../../helpers/mixins/variables/tacco'

export default {
  name: 'Suola',
  props: [
    'orderbool',
    'mod',
    'availablebatt',
    'availableinter',
    'disabledbool',
    'disabledboolcolor',
    'orderInfoMandatory',
    'foggiaInfoMandatory',
    'isSimplified',
    'isOptional',
  ],
  data() {
    return {
      image1: null,
      image2: null,
      image3: null,
      disabledtacc: false,
      campValueMedSx: null,
      campValueMedDx: null,
      campValueLatSx: null,
      campValueLatDx: null,
    }
  },
  inject: ['$validator'],
  computed: {
    isCustomRequired() {
      return !!this.mod.custom && !this.mod.from_duna_catalog && !this.isOptional
    },
    baseRequired() {
      return this.isCustomRequired || !!this.orderInfoMandatory
    },
    foggiaRequired() {
      return this.isCustomRequired || !!this.foggiaInfoMandatory
    },
    availabletacczepp: function() {
      return this.availableinter.filter(mat => mat.CUI != '-')
    },
  },
  watch: {
    mod: function() {
      this.updateAfterload()
    },
  },
  methods: {
    UpdateCamp() {
      this.mod.camp_num_M_sx = this.campValueMedSx || null
      this.mod.camp_num_M_dx = this.campValueMedDx || null
      this.mod.camp_num_L_sx = this.campValueLatSx || null
      this.mod.camp_num_L_dx = this.campValueLatDx || null
    },
    EmptyCamp(camp) {
      this.mod[camp] = null
      this.campValueMedSx = this.mod.camp_num_M_sx || null
      this.campValueMedDx = this.mod.camp_num_M_dx || null
      this.campValueLatSx = this.mod.camp_num_L_sx || null
      this.campValueLatDx = this.mod.camp_num_L_dx || null
      this.$forceUpdate()
    },
    changepell1() {
      var newbatt = this.availablebatt.find(el => el.id == this.mod.battmat)
      if (newbatt) {
        var boolcheckpunta = false

        newbatt.optional_tag.forEach(singletag => {
          if ('no punta risvoltata' == singletag.key) {
            boolcheckpunta = true
          }
        })

        if (boolcheckpunta) {
          this.mod.punt_risv = false
          this.disabledtacc = true
        } else {
          this.disabledtacc = false
        }
      }
      this.mod.battvar = null
      this.image1 = null
    },
    changepell2() {
      this.mod.intevar = null
      this.image2 = null
    },
    changepell3() {
      this.mod.tacczeppvar = null
      this.image3 = null
    },
    changeImage1() {
      this.image1 = null
      for (let index in this.availablebatt) {
        if (this.availablebatt[index].id == this.mod.battmat) {
          for (let index2 in this.availablebatt[index].variants) {
            if (this.availablebatt[index].variants[index2].id == this.mod.battvar) {
              this.image1 = this.availablebatt[index].variants[index2].image
            }
          }
        }
      }
    },
    changeImage2() {
      this.image2 = null
      for (let index in this.availableinter) {
        if (this.availableinter[index].id == this.mod.intemat) {
          for (let index2 in this.availableinter[index].variants) {
            if (this.availableinter[index].variants[index2].id == this.mod.intevar) {
              this.image2 = this.availableinter[index].variants[index2].image
            }
          }
        }
      }
    },
    changeImage3() {
      this.image3 = null
      for (let index in this.availableinter) {
        if (this.availableinter[index].id == this.mod.tacczepp) {
          for (let index2 in this.availableinter[index].variants) {
            if (this.availableinter[index].variants[index2].id == this.mod.tacczeppvar) {
              this.image3 = this.availableinter[index].variants[index2].image
            }
          }
        }
      }
    },

    updateAfterload() {
      this.campValueMedDx = this.mod.camp_num_M_dx || null
      this.campValueMedSx = this.mod.camp_num_M_sx || null
      this.campValueLatDx = this.mod.camp_num_L_dx || null
      this.campValueLatSx = this.mod.camp_num_L_sx || null
      // Commentata riga successiva per bug rilevato 06/10/2020
      // this.changepell1();
      this.changeImage1()
      this.changeImage2()
      this.changeImage3()
    },
  },
}
</script>
